import { render, staticRenderFns } from "./transaksi.vue?vue&type=template&id=732ac15e&scoped=true&"
import script from "./transaksi.vue?vue&type=script&lang=js&"
export * from "./transaksi.vue?vue&type=script&lang=js&"
import style0 from "./transaksi.vue?vue&type=style&index=0&id=732ac15e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732ac15e",
  null
  
)

export default component.exports